import { render, staticRenderFns } from "./AuthenticationForm.vue?vue&type=template&id=1d2c6757"
import script from "./AuthenticationForm.vue?vue&type=script&lang=js"
export * from "./AuthenticationForm.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationForm.vue?vue&type=style&index=0&id=1d2c6757&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports